<template>
    <div>

        <trax-ui-card-icon-header class="mt-5"
            header-color="info" icon="playlist_add_check" :title="lang.polaris.dashboard.skills_progress"
            :actions="actions" :bus="bus"
        >
            <div v-show="loaded" class="skills-progress-container">
                <table>
                    <tbody>
                        <!-- Modules -->
                        <tr v-if="titles.length > 3">
                            <th v-for="(col, index) in titles" :key="index" :colspan="col.colspan" :class="col.type">
                                <span> {{ col.title }} </span>
                            </th>
                            <th class="headcol"></th>
                        </tr>
                        <!-- Units -->
                        <tr>
                            <th v-for="(col, index) in cols" :key="index" :class="col.type">
                                <enac-atpl-dashboard-skills-progress-item v-if="col.type == 'unit'"
                                    :id="col.data.id" :item="col.data" :states="states" :bus="bus">
                                </enac-atpl-dashboard-skills-progress-item>
                                <div class="p-1" v-if="col.type == 'delimiter-left'"></div>
                                <div class="p-1" v-if="col.type == 'delimiter-right'"></div>
                            </th>
                            <th class="headcol"></th>
                        </tr>
                        <!-- Grade -->
                        <tr>
                            <td v-for="(col, index) in cols" :key="index" :class="col.type" class="pb-3"
                                v-html="gradeRendering(col)"
                            >
                            </td>
                            <td class="headcol font-weight-bold"></td>
                        </tr>
                        <!-- Competencies -->
                        <tr v-for="competency in competency_domains_select" :key="competency.value">
                            <td v-for="(col, index) in cols" :key="index" :class="col.type"
                                v-html="competencyRendering(col, competency.value)"
                            >
                            </td>
                            <td class="headcol">
                                <a :href="competencyLink(competency.value)" class="btn btn-sm btn-white w-100">
                                    {{ competency_domains_tags[competency.value] }}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </trax-ui-card-icon-header>
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-skills-progress'}
        },
    
        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                registration: data.registration,
                phase: data.phase,
                learner: data.learner,
                competency_domains_select: data.competency_domains_select,
                competency_domains_tags: data.competency_domains_tags,
                unitsLoaded: false,
                statesLoaded: false,
                endpoint: app_url+'polaris/api/front/sections',
                endpointParams: {
                    options: {
                        registration: data.registration.id,
                        user: data.learner.id
                    },
                    filters: {
                        phase_id: data.phase.id
                    },
                    sort: ['order']
                },
                endpoint_states: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/phases/'+data.phase.id+'/learners/'+data.learner.id+'/with-competencies',
                sections: [],
                states : {},
                titles: [],
                cols: [],
                timeMode: true,
                bus: new Vue()
            }
        },

        created: function() {
            this.getData();
            this.getStates();

            this.bus.$on('switch-mode', this.switchMode);
        },

        computed: {

            loaded() {
                return this.unitsLoaded && this.statesLoaded
            },

            actions() {
                return [
                    {
                        name: this.timeMode ? 'Switch to modules view' : 'Switch to time view',
                        color: 'default',
                        event: 'switch-mode' 
                    }
                ]
            }
        },

        watch: {

            loaded() {
                this.initCols()
            }
        },
        
        methods: {

            switchMode() {
                this.timeMode = !this.timeMode
                this.initCols()
            },

            competencyLink(code) {
                return this.app_url + 'polaris/ui/atpl-dashboard/registration/' + this.registration.id + '/enac-atpl-phase/' + this.phase.id + '/learner/' + this.learner.id + '/skills-progress/' + code
            },

            programUnit(learning_unit) {
                return !learning_unit.registration_id;
            },

            groupUnit(learning_unit) {
                return learning_unit.registration_id && !learning_unit.user_id;
            },

            userUnit(learning_unit) {
                return learning_unit.user_id;
            },

            unitWithCompetencies(learning_unit) {
                return learning_unit.type == 'enac-atpl-simu-session'
                    || learning_unit.type == 'enac-atpl-flight-session'
                    || learning_unit.type == 'enac-atpl-level-report'
                    ;
            },

            getData() {
                var that = this;
                axios.get(that.endpoint, {params: that.endpointParams})
                    .then(function (response) {
                        that.sections = response.data.data;
                        that.unitsLoaded = true;
                    })
                    .catch(function (error) {
                    });
            },

            getStates() {
                var that = this;
                axios.get(this.endpoint_states)
                    .then(function (response) {
                        that.states = Array.isArray(response.data.data) ? {} : response.data.data;
                        that.statesLoaded = true;
                    })
                    .catch(function (error) {
                    });
            },

            initCols() {
                if (this.timeMode) {
                    this.initColsByTime()
                } else {
                    this.initColsByModules()
                }
            },

            initColsByTime() {
                this.titles = []
                this.cols = []
                
                // Merge all the units.
                var units = []
                for (var index in this.sections) {
                    var section = this.sections[index]
                    var programUnits = section.learning_units.filter(unit => this.programUnit(unit) && this.unitWithCompetencies(unit))
                    var groupUnits = section.learning_units.filter(unit => this.groupUnit(unit) && this.unitWithCompetencies(unit))
                    var userUnits = section.learning_units.filter(unit => this.userUnit(unit) && this.unitWithCompetencies(unit))

                    units = [...units, ...programUnits, ...groupUnits, ...userUnits]
                }
                
                // Sort them.
                var sorted = units.sort((a, b) => {
                    var stateA = this.states[a.id]
                    var stateB = this.states[b.id]
                    if (!stateA && !stateB) {
                        return 0
                    }
                    if (!stateA && stateB) {
                        return 1
                    }
                    if (stateA && !stateB) {
                        return -1
                    }
                    if (!stateA.date) {
                        return 1
                    }
                    if (!stateB.date) {
                        return -1
                    }
                    if (stateA.date == stateB.date) {
                        return 0
                    }
                    return stateA.date > stateB.date ? 1 : -1
                })

                // Add them to the cols
                for (var index in sorted) {
                    var unit = sorted[index]
                    this.cols.push({
                        type: 'unit',
                        data: unit,
                    })
                }
            },

            initColsByModules() {
                this.titles = []
                this.cols = []
                
                for (var index in this.sections) {
                    var section = this.sections[index]
                    var programUnits = section.learning_units.filter(unit => this.programUnit(unit) && this.unitWithCompetencies(unit))
                    var groupUnits = section.learning_units.filter(unit => this.groupUnit(unit) && this.unitWithCompetencies(unit))
                    var userUnits = section.learning_units.filter(unit => this.userUnit(unit) && this.unitWithCompetencies(unit))
                    var length = programUnits.length + groupUnits.length + userUnits.length

                    if (length == 0) {
                        continue
                    }

                    // Titles.
                    this.titles.push({
                        colspan: length,
                        title: section.name,
                        type: 'module',
                    })
                    this.titles.push({
                        colspan: 1,
                        title: '',
                        type: 'delimiter-left',
                    })
                    this.titles.push({
                        colspan: 1,
                        title: '',
                        type: 'delimiter-right',
                    })

                    // First the program units.
                    for (var index2 in programUnits) {
                        var unit = programUnits[index2]
                        this.cols.push({
                            type: 'unit',
                            data: unit,
                        })
                    }
                   // Then the group units.
                   if (groupUnits.length > 0) {
                        for (var index2 in groupUnits) {
                            var unit = groupUnits[index2]
                            this.cols.push({
                                type: 'unit',
                                data: unit,
                            })
                        }
                   }

                    // Finally the user units.
                    if (userUnits.length > 0) {
                        for (var index2 in userUnits) {
                            var unit = userUnits[index2]
                            this.cols.push({
                                type: 'unit',
                                data: unit,
                            })
                        }
                    }

                    // Section delimiter.
                    this.cols.push({
                        type: 'delimiter-left',
                        data: section
                    })
                    this.cols.push({
                        type: 'delimiter-right',
                        data: section
                    })
                }
            },

            gradeRendering(col) {
                if (col.type != 'unit') {
                    return ''
                }
                var state = this.states[col.data.id]
                if (!state) {
                    return ''
                }
                if (state.grade) {
                    return this.gradeHtml(state.grade, state.color_status)
                }
                if (state.passed === undefined) {
                    return ''
                }
                if (col.data.type == 'enac-atpl-level-report') {
                    return this.gradeHtml(state.passed ? 'S' : 'U', state.color_status)
                }
                return this.gradeHtml(state.passed ? 'P' : 'F', state.color_status)
            },

            gradeHtml(content, color) {
                return '<div class="font-weight-bold text-center text-' + color + '">' + content + '</div>'
            },

            competencyRendering(col, competencyCode) {
                if (col.type != 'unit') {
                    return this.competencyHtml(0)
                }
                var state = this.states[col.data.id]
                if (!state || !state.competencies || !state.competencies[competencyCode]) {
                    return this.competencyHtml(0)
                }
                return this.competencyHtml(state.competencies[competencyCode].level)
            },

            competencyHtml(level) {
                var html = '';
                html += '<div style="height:44px;">'
                html += '<div style="height:1px;border-bottom:1px solid #aaa;position:relative;top:22px;"></div>';

                if (level == 3) {
                    html += '<div class="bg-success" style="width:16px;height:16px;position:relative;top:14px;left:10px;border-radius:8px"></div>';
                }
                if (level == 2) {
                    html += '<div class="bg-warning" style="width:16px;height:16px;position:relative;top:14px;left:10px;border-radius:8px"></div>';
                }
                if (level == 1) {
                    html += '<div class="bg-danger" style="width:16px;height:16px;position:relative;top:14px;left:10px;border-radius:8px"></div>';
                }
                html += '</div>'
                return html
            },

            competencyHtml2(level) {
                var html = '<table style="width:100%" class="mb-2">';
                var color = 'white'

                color = level == 3 ? 'success' : 'white'
                html += '<tr><td class="bg-' + color + '" style="height:8px;"></td></tr>'

                color = level == 2 ? 'warning' : 'white'
                html += '<tr><td class="bg-' + color + '" style="height:8px;"></td></tr>'

                color = level == 1 ? 'danger' : 'white'
                html += '<tr><td class="bg-' + color + '" style="height:8px;"></td></tr>'

                html += '</table>'
                return html
            },
        }
    }
</script>

<style scoped>

    .skills-progress-container {
        overflow-x: auto;
    }
    .headcol {
        position: absolute;
        left: 20px;
        top: auto;
        width: 70px;
        padding-top: 3px;
    }
    table {
        margin-left: 70px;
    }
    table td {
        padding: 0;
    }
    table th.unit,
    table td.unit {
        width: 38px;
    }
    table th.delimiter-left,
    table td.delimiter-left {
        border-right: 3px #aaa solid;
    }
    
</style>